import type { FaireProductEntity } from "../../entity_types/product";

export const p_qk2vqquxas: FaireProductEntity = {
  token: "p_qk2vqquxas",
  type: "product",
  name: "Organic Blueboon Blend, 5 lb Bulk",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/5468a4614d90babcc539810cf615e11ab2a5404663d7e455efd116c3d4da0ae8.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/337a084181fec3fe5af1a35b3ebbd396423c37b40c5003dbdb30ad93d8d13190.webp",
    "https://cdn.faire.com/fastly/f928e7395a8d2156c80323692c8f5924e5a19ed48ce8213e554f99ffe6715888.webp",
    "https://cdn.faire.com/fastly/6138d821a079519740794abf26635e1437a3bf467a3b8e6f7492d2174cb6b756.webp",
    "https://cdn.faire.com/fastly/5a8daf23401c225ad94b6f84cb1874095ddbc90bcabcea4f30747792f8bfb175.webp"
  ],
  priceDollars: 70.5,
  description: "Blueboon is our well-balanced, versatile blend that celebrates simple, approachable flavors of milk chocolate, citrus, and stone fruits. We change the components seasonally, so the coffees are always fresh and the balance of sweetness, body, and acidity is just right. This is our go-to Saturday morning cup.\n\nCCOF Certified Organic\n\nTaste notes // Milk Chocolate, Mandarin, Honeysuckle\n\nRoast profile // Light-Medium\n\nRecommended brew methods // V60, Chemex, Aeropress\n\nShelf life // All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 90 days of the roast date for optimal freshness and flavor.",
  tags: [],
  msrpDollars: 141,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:08.863Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
